import { Component, OnInit } from '@angular/core';
import { FieldConfig } from '../dynamic-form/dynamic-form-config.interface';
import { FormGroup } from '@angular/forms';
import { BooleanSelectionService } from './boolean-selection.service';

@Component({
  selector: 'app-boolean-selection',
  templateUrl: './boolean-selection.component.html',
  styleUrls: ['./boolean-selection.component.scss']
})
export class BooleanSelectionComponent implements OnInit {

  field: FieldConfig;
  group: FormGroup;

  constructor(private booleanSelectionService: BooleanSelectionService) { }

  ngOnInit(): void {
    if (this.field && this.field.label && this.field.label==='true'){
      this.setValue(true);
    }
  }

  setValue(value: boolean | null): void {
    this.group.controls[this.field.name].setValue(value);

    this.booleanSelectionService.onSelectionChange(value);
  }

  changeSelectionColor(selectedValue: boolean): boolean {
    if (this.group.controls[this.field.name].value !== null && selectedValue === this.group.controls[this.field.name].value) {
      return true;
    }else{
      return false;
    }
  }

}
